import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Button,
} from "@material-ui/core";
import Dropzone from "../components/micro_components/DropZone";
import { useState } from "react";
import "./styles/BookDetails.css";

export default function BookDetails() {
  const [title, setTitle] = useState("");
  const [domain, setDomain] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [coverImage, setCoverImage] = useState();
  const [category, setCategory] = useState([]);
  const [creators, setCreators] = useState([]);
  const [description, setDescription] = useState("");
  const [languages, setLanguages] = useState([]);
  const [commentary, setCommentary] = useState("");
  const [score, setScore] = useState("");
  const [difficulty, setDifficulty] = useState("");
  const [hasPdf, setHasPdf] = useState(false);
  const [isDpiPdf, setIsDpiPdf] = useState(false);
  const [pdfLink, setPdfLink] = useState("");
  const [pdfCoupon, setPdfCoupon] = useState("");
  const [sampleVideoLink, setSampleVideoLink] = useState("");
  const [isPublishingBook, setIsPublishingBook] = useState(false);
  const [publisherName, setPublisherName] = useState("");
  const [price, setPrice] = useState();
  const [instrument, setInstrument] = useState("");

  const data = {
    domains: ["Guitar By Masters", "Percussion By Masters", "Piano By Masters"],
    creators: [
      "Test creator 1",
      "Test creator 2",
      "Test creator 3",
      "Test creator 4",
    ],
    creatorTypes: [
      "Composer",
      "Arranger",
      "Performer",
      "Teacher",
      "Editor",
      "Re-creator",
      "Writer",
    ],
    categories: [
      "Test category 1",
      "Test category 2",
      "Test category 3",
      "Test category 4",
    ],
    languages: ["English", "Spanish", "Chinese", "French"],
    commentary: ["Audio", "Video"],
    score: ["Audio", "Video"],
    difficulty: ["Basic", "Intermediate", "Intermediate-Advanced", "Advanced"],
    instruments: ["Guitar", "Piano", "Percussion"],
    publishers: ["Digital Publishing Inc", "Alfred"],
    bookCover: null,
  };

  return (
    <>
      <h1>Book Details</h1>
      <hr />
      <div className="book-details__container">
        <div>
          <h4>Title</h4>
          <TextField
            placeholder="Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          ></TextField>
        </div>
        <div>
          <h4>Cover Image</h4>
          <Dropzone
            originalFile={data.bookCover}
            setFileData={(data) => setCoverImage(data)}
            width={220}
            height={330}
          />
        </div>
        <div>
          <h4>Domain</h4>
          <SelectBox
            name="Domain"
            value={domain}
            setValue={setDomain}
            items={data.domains}
          />
        </div>
        <div>
          <h4>Categories</h4>
          <MultiSelectBox
            name="Categories"
            values={category}
            setValue={setCategory}
            items={data.categories}
          />
        </div>
        <div>
          <h4>Creators</h4>
          <CreatorMultiSelectBox
            name="Creators"
            values={creators}
            setValue={setCreators}
            items={data.creators}
            dropDownItems={data.creatorTypes}
          />
        </div>
        <div className="book-details__description-box">
          <h4>Description</h4>
          <TextField
            placeholder="Book Description"
            multiline
            variant="outlined"
            minRows={8}
            maxRows={8}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            fullWidth
          />
        </div>
        <div>
          <h4>Languages</h4>
          <MultiSelectBox
            name="Languages"
            values={languages}
            setValue={setLanguages}
            items={data.languages}
          />
        </div>
        <div>
          <h4>Commentary</h4>
          <SelectBox
            name="Commentary"
            value={commentary}
            setValue={setCommentary}
            items={data.commentary}
          />
        </div>
        <div>
          <h4>Score</h4>
          <SelectBox
            name="Score"
            value={score}
            setValue={setScore}
            items={data.score}
          />
        </div>
        <div>
          <h4>Difficulty</h4>
          <SelectBox
            name="Difficiulty"
            value={difficulty}
            setValue={setDifficulty}
            items={data.difficulty}
          />
        </div>
        <div>
          <h4>Sample Video Link</h4>
          <TextField
            placeholder="Sample Video Link"
            value={sampleVideoLink}
            onChange={(e) => setSampleVideoLink(e.target.value)}
          />
        </div>
        <div>
          <h4>PDF</h4>
          <Check value={hasPdf} setValue={setHasPdf} label="Has pdf" />
          {hasPdf && (
            <>
              <TextField
                placeholder="PDF Link"
                value={pdfLink}
                onChange={(e) => setPdfLink(e.target.value)}
              />
              <Check value={isDpiPdf} setValue={setIsDpiPdf} label="Dpi pdf" />
              {isDpiPdf && (
                <TextField
                  placeholder="PDF member coupon"
                  value={pdfCoupon}
                  onChange={(e) => setPdfCoupon(e.target.value)}
                />
              )}
            </>
          )}
        </div>
        <div className="book-details__publisher-section">
          <h4>Publishing</h4>
          <Check
            value={isPublishingBook}
            setValue={setIsPublishingBook}
            label="Publishing Book"
          />
          {isPublishingBook && (
            <>
              <div>
                <SelectBox
                  name="Publisher"
                  value={publisherName}
                  setValue={setPublisherName}
                  items={data.publishers}
                />
              </div>
              <div>
                <TextField
                  placeholder="Price"
                  type="number"
                  value={price}
                  label="Price"
                  onChange={(e) => setPrice(e.target.value)}
                />
              </div>
              <div>
                <SelectBox
                  name="Instrument"
                  value={instrument}
                  setValue={setInstrument}
                  items={data.instruments}
                />
              </div>
            </>
          )}
        </div>
        <div className="book-details__save-button">
          <Button color="primary" variant="contained" fullWidth>
            Save
          </Button>
        </div>
      </div>
    </>
  );
}

function SelectBox({ name, value, setValue, items }) {
  return (
    <FormControl fullwidth>
      <InputLabel id={name}>{name} </InputLabel>
      <Select
        id={`${name}Select`}
        labelId={name}
        value={value}
        label={name.replace(/([a-z](?=[A-Z]))/g, "$1 ")}
        onChange={(e) => setValue(e.target.value)}
      >
        {items.map((item, i) => {
          console.log(`item: ${i}`);
          console.log(item);

          return (
            <MenuItem key={i} value={item}>
              {item}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}

function MultiSelectBox({ name, values, setValue, items }) {
  return (
    <FormControl fullwidth>
      <InputLabel>{name}</InputLabel>
      <Select
        id={`${name}Select`}
        labelId={name}
        value={values}
        renderValue={(values) =>
          values.length > 0 ? values.join(",") : <em>Nothing Selected</em>
        }
        label={name.replace(/([a-z](?=[A-Z]))/g, "$1 ")}
        onChange={(e) => {
          if (!values.includes(e.target.value)) {
            setValue([...values, e.target.value]);
          } else {
            let copy = [...values];
            let index = [values.indexOf(e.target.value)];
            copy.splice(index, 1);
            setValue(copy);
          }
        }}
      >
        {items.map((item, i) => (
          <MenuItem key={i} value={item}>
            {item}
            <Checkbox checked={values.includes(item)} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

function CreatorMultiSelectBox({
  name,
  values,
  setValue,
  items,
  dropDownItems,
}) {
  return (
    <FormControl fullwidth>
      <InputLabel>{name}</InputLabel>
      <Select
        id={`${name}Select`}
        labelId={name}
        value={values}
        renderValue={(values) =>
          values.length > 0 ? (
            values.map((value) => value.creator).join(",")
          ) : (
            <em>Nothing Selected</em>
          )
        }
        label={name.replace(/([a-z](?=[A-Z]))/g, "$1 ")}
        onChange={(e) => {
          if (!values.map((value) => value.creator).includes(e.target.value)) {
            setValue([...values, { creator: e.target.value }]);
          } else {
            let copy = [...values];
            let index = [
              values.map((value) => value.creator).indexOf(e.target.value),
            ];
            copy.splice(index, 1);
            setValue(copy);
          }
        }}
      >
        {items.map((item, i) => (
          <MenuItem key={i} value={item}>
            {item}
            <Checkbox
              checked={values.map((value) => value.creator).includes(item)}
            />
            {values.map((value) => value.creator).includes(item) && (
              <SelectBox name="Creator Type" />
            )}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

function Check({ label, value, setValue }) {
  return (
    <FormGroup>
      <FormControlLabel
        control={<Checkbox checked={value} onChange={() => setValue(!value)} />}
        label={label}
      />
    </FormGroup>
  );
}
